import * as React from "react";
import { withNamespaces, WithNamespaces } from "react-i18next";
import {
  ResponseTypes,
  PayloadPov,
  ResponsePov,
  ProposalPOV,
  AttachFile
} from "src/redux/projects";
import history from "src/plugins/history";
import { Loader } from "./Loader";
import { CurrentResponse } from "src/redux/currentResponses";
import { setUploadFiles } from "src/api/projects";
import { toast } from "react-toastify";
import { config } from "src/config/config";
interface Props {
  response: CurrentResponse | undefined;
  isLocked: boolean;
  proposal: ProposalPOV;
  setCurrentProposalResponseType: (
    proposalUuid: string,
    responseType: ResponseTypes
  ) => void;
  setCurrentProposalResponseForPov: (
    proposalUuid: string,
    ressourceId: number,
    comment: string
  ) => void;
  handleSubmitProposal: (response: ResponsePov | undefined) => void;
  handleChangePov: (ressourceId) => void;
  currentId: number;
  step: number;
  onChangeStep: (step: number) => void;
}
type PropsWithNamespaces = Props & WithNamespaces;

interface State {
  comment: string;
  loader: boolean;
  files: AttachFile[];
}
class PovSidebar extends React.Component<PropsWithNamespaces, State> {
  state: State = {
    comment:
      this.props.response && this.props.response.response
        ? (this.props.response.response.payload as PayloadPov).comment
        : "",
    files:
      this.props.response &&
      this.props.response.response &&
      (this.props.response.response.payload as PayloadPov).files
        ? (this.props.response.response.payload as PayloadPov).files
        : [],
    loader: false
  };
  onHandleChangeComment = e => {
    this.setState({ comment: e.target.value });
  };

  handleChangeResponse = response => {
    this.props.setCurrentProposalResponseType(
      this.props.proposal.uuid,
      response
    );
    this.props.onChangeStep(1);
  };
  onSubmit = e => {
    this.setState({
      loader: true
    });
    e.preventDefault();

    // Add comment to response
    const response = {
      ...(this.props.response && (this.props.response.response as ResponsePov)),
      ressourceId: this.props.currentId,
      payload: {
        comment: this.state.comment,
        files: this.state.files
      }
    };

    this.props.handleSubmitProposal(response as ResponsePov);
  };
  onChangeFile = async ev => {
    try {
      if (ev.target.files[0].size > config.maxFileSizeUpload) {
        toast.error(this.props.t("proposal.files.maximumSizeExceeded"));
        return;
      }
      const file = await setUploadFiles(ev.target.files[0]);
      this.setState({
        files: [...this.state.files, file]
      });
    } catch (e) {
      if (e.response.data.message === "UNVALID_EXTENSION") {
        toast.error(this.props.t("proposal.files.unvalidExtension"));
        return;
      }
      toast.error("Upload files error");
    }
  };
  deleteFile = file => {
    this.setState({
      files: [...this.state.files.filter(f => f.id !== file.id)]
    });
  };
  onBack = e => {
    history.goBack();
  };
  render() {
    const currentResponseType = this.props.proposal.responses
      ? this.props.proposal.responses[0].responseType
      : ResponseTypes.Rejected;
    const files =
      this.props.proposal.responses &&
      this.props.proposal.responses[0].payload &&
      this.props.proposal.responses[0].payload.files
        ? this.props.proposal.responses[0].payload.files
        : [];
    const comment =
      this.props.proposal.responses && this.props.proposal.responses[0].payload
        ? this.props.proposal.responses[0].payload.comment
        : "";
    return (
      <div className="sidebar-right">
        <div
          className={`step step-end ${this.props.step === 1 ? "active" : ""}`}
        >
          <div className="sidebar-right-infos flex-column">
            <p className="title mb-0">
              {this.props.t("proposal.pov.titleValidation")}
            </p>
            <div>
              <small className="font-weight-bold">
                {this.props.t("proposal.session")}
                {this.props.proposal.session}
              </small>
            </div>
          </div>
          <div className="sidebar-right-items">
            <div className="sidebar-right-items-item p-3 flex-column">
              <p>{this.props.t("proposal.pov.comment")} :</p>
              <textarea onChange={e => this.onHandleChangeComment(e)} />
            </div>
            <div className="pl-3 pr-3">
              <label className="cursor-pointer">
                <img className="mr-2" width="20px" src="assets/svgs/clip.svg" />
                <input
                  type="file"
                  className="d-none"
                  onChange={this.onChangeFile}
                />
                {this.props.t("proposal.artwork.validation.fileUrl")}
                <small className="ml-1">
                  {this.props.t("proposal.files.maximumSize")}
                </small>
              </label>
              {this.state.files.length > 0 && (
                <div>
                  <p className=" mt-2 mb-2">
                    {this.props.t("proposal.files.title")}
                  </p>
                  <div>
                    {this.state.files.map(file => (
                      <div className="d-flex" key={file.id}>
                        <a className="flex-1" target="_blank" href={file.url}>
                          <img
                            width="16px"
                            src="assets/svgs/outline-cloud_download.svg"
                          />
                          <small className="ml-2">{file.filename}</small>
                        </a>

                        <img
                          onClick={e => this.deleteFile(file)}
                          src="/assets/svgs/baseline-close.svg"
                          width="16px"
                          className="cursor-pointer"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="m-auto text-center w-100">
            <button
              onClick={e => this.props.onChangeStep(0)}
              className="btn text-underline btn-transparent"
              style={{ textDecoration: "underline" }}
            >
              {this.props.t("proposal.btnBack")}
            </button>
            <button onClick={this.onSubmit} className="btn btn-primary ">
              {!this.state.loader && (
                <div>
                  {this.props.t("button.validAndSend")}
                  <img
                    className="ml-1"
                    src="assets/svgs/right-chevron-white.svg"
                    width="10px"
                  />
                </div>
              )}
              {this.state.loader && <Loader />}
            </button>
          </div>
        </div>
        <div
          className={`step step-start ${this.props.step === 0 ? "active" : ""}`}
        >
          <div className="sidebar-right-infos flex-column">
            <p className="title mb-0"> {this.props.t("proposal.pov.title")}</p>
            <div>
              <small className="font-weight-bold">
                {this.props.t("proposal.session")}
                {this.props.proposal.session}
              </small>
            </div>
          </div>
          <div className="sidebar-right-items">
            {this.props.proposal.ressources.map(r => (
              <div
                key={r.id}
                className={`sidebar-right-items-item ${
                  this.props.currentId === r.id ? "current" : ""
                }`}
              >
                <label className="m-auto" htmlFor={`pov-${r.id}`}>
                  <img className="vignette" width="150px" src={r.thumb} />
                  <input
                    onChange={e =>
                      !this.props.isLocked
                        ? this.props.handleChangePov(r.id)
                        : e.preventDefault()
                    }
                    checked={this.props.currentId === r.id}
                    type="radio"
                    name="ressource"
                    id={`pov-${r.id}`}
                    className="d-none"
                  />
                  <p className="label">{r.label}</p>
                </label>
              </div>
            ))}
          </div>
          <div className="m-auto ">
            {this.props.isLocked && (
              <div className="p-2">
                <div className="pov align-items-center text-center">
                  <span className="font-weight-bold">
                    {currentResponseType === ResponseTypes.Rejected && (
                      <span>{this.props.t("proposal.pov.rejected")}</span>
                    )}
                    {currentResponseType === ResponseTypes.Validated && (
                      <span>{this.props.t("proposal.pov.accepted")}</span>
                    )}
                  </span>
                  <p className="pov align-items-center mt-2 mb-0">{comment}</p>
                  {files.length > 0 && (
                    <div className="text-left">
                      <p className=" mt-2 mb-2">
                        {this.props.t("proposal.files.title")}
                      </p>
                      <div>
                        {files.map(file => (
                          <div className="d-flex" key={file.id}>
                            <a
                              className="flex-1"
                              target="_blank"
                              href={file.url}
                            >
                              <img
                                width="16px"
                                src="assets/svgs/outline-cloud_download.svg"
                              />
                              <small className="ml-2">{file.filename}</small>
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {!this.props.isLocked && (
              <div className="text-center">
                <button
                  onClick={e =>
                    this.handleChangeResponse(ResponseTypes.Rejected)
                  }
                  className="btn btn-transparent"
                >
                  {this.props.t("proposal.pov.reject")}
                  <img
                    className="ml-1"
                    src="assets/svgs/right-chevron.svg"
                    width="10px"
                  />
                </button>
                <button
                  onClick={e =>
                    this.handleChangeResponse(ResponseTypes.Validated)
                  }
                  className="btn btn-primary"
                >
                  {this.props.t("proposal.pov.validation")}
                  <img
                    className="ml-1"
                    src="assets/svgs/right-chevron-white.svg"
                    width="10px"
                  />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default withNamespaces()(PovSidebar);



// WEBPACK FOOTER //
// ./src/components/PovSidebar.tsx